import { render, staticRenderFns } from "./QAccountTopoff.vue?vue&type=template&id=b12852d2&scoped=true&"
import script from "./QAccountTopoff.vue?vue&type=script&lang=js&"
export * from "./QAccountTopoff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12852d2",
  null
  
)

export default component.exports